import Component from '../classes/Component';
import api from './instance';
import is from 'is_js';
import {warn} from "../helpers/_utilities";

export default function () {
    const $Page = this;

    return new Component({
        name: 'api_errorHandler',
        requiredTargets: 'STAND_ALONE',
        onInit() {
            if ($Page.components && $Page.components.toast) {
                api.interceptors.response.handlers = [];

                api.interceptors.response.use(
                    ({data}) => {
                        if (data.message && !data.status && (data?.warningType !== 'modal'))
                            $Page.components.toast.show(data.message, 'danger');
                        return data
                    },
                    (error) => {
                        const {response} = error;
                        const {data} = response;

                        if (data) {
                            let errorText = 'Unknown error';
                            if (data.errors) {
                                const errorsArr = Object.values(data.errors);
                                if (errorsArr.length > 0) {
                                    errorText = errorsArr
                                        .reduce((acc, value) => {
                                            acc += value.join('<br>')
                                            return acc
                                        }, '')
                                }
                            } else if (data.message && is.string(data.message)) {
                                errorText = data.message;
                            }

                            $Page.components.toast.show(errorText, 'danger');
                        } else {
                            $Page.components.toast.show(error.message, 'danger');
                        }

                        throw error;
                    }
                );
            } else {
                warn('api errorHandler required toast Component!')
            }

        }
    })
}
